import { forwardRef, useCallback } from 'react';

import dynamic from 'next/dynamic';

import { DisclaimerAccordion, Footer, FooterProps } from '@arrived/components';
import { Issuer } from '@arrived/models';

import { NextMuiLink } from '../Link';

// Because the DisclaimerAccordion uses local storage to determine how it is displayed (open/closed) it can't be
// rendered server side.
const DisclaimerAccordionNoSSR = dynamic(() => Promise.resolve(DisclaimerAccordion), { ssr: false });

export interface PublicFooterProps extends Omit<FooterProps, 'RouteLink'> {
  isReserve?: boolean;
  issuerId?: Issuer['id'];
}

// TODO: This component is duplicated between city-pages-app and public-app, should be reduced to a single component
//  with a combined "public-components" folder.
export const PublicFooter = forwardRef(({ isReserve, issuerId, ...rest }: PublicFooterProps, ref) => {
  const RouteLink = useCallback(
    (link: string, text: JSX.Element) => (
      <NextMuiLink href={link} color="inherit">
        {text}
      </NextMuiLink>
    ),
    [],
  );

  return (
    <Footer RouteLink={RouteLink} ref={ref} {...rest}>
      <DisclaimerAccordionNoSSR isReserve={isReserve} issuerId={issuerId} />
    </Footer>
  );
});
